module.exports = __webpack_public_path__ + "media/images/lb/196-6a360bfa4d3f7f81176518724055fe4f.svg";